import React from 'react';
import "./agent-ui.css";

const ActiveTenants = () => {
  return (
    <div className='active-tenants'>
        <h3>Active Tenants</h3>
    </div>
  )
}

export default ActiveTenants